import { Typography } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import type { BillingInterval } from '@weft/types';
import React from 'react';
import VyDialog from '../../../../../components/new-design/feedback/VyDialog';
import { useDialog } from '../../../../../hooks/use-dialog';
import { useVyNavigate } from '../../../../../hooks/use-vy-navigate';

type MenuItemUpdateContractProps = {
  contractId: string;
  contractStartDate: Date;
  billingInterval: BillingInterval;
  disabled?: boolean;
};

export const MenuItemUpdateContract: React.FC<MenuItemUpdateContractProps> = ({ contractId, contractStartDate: _contractStartDate, billingInterval: _billingInterval, disabled }) => {
  const navigate = useVyNavigate();
  const { isDialogOpen, handleOpen, handleClose } = useDialog();

  // TODO: Uncomment this when we have need to validate that the contract is in the first billing cycle
  // const contractFirstBillingCycle = getContractFirstBillingCycle(contractStartDate, billingInterval);
  // const today = new Date();
  //
  // if (!isDateBetween(today, contractFirstBillingCycle)) {
  //   return null;
  // }

  const handleDialogSubmit = () => {
    navigate(`/plans/contracts/${contractId}/update`);
    handleClose();
  };

  return (
    <>
      <MenuItem
        className='pb-2'
        disabled={disabled}
        onClick={handleOpen}
      >
        <Typography>Edit</Typography>
      </MenuItem>
      
      <VyDialog
        open={isDialogOpen}
        onClose={handleClose}
        label="Contract Edit"
        labelDescription="Modify the contract to fix errors that arose during contract creation."
        warningText="Use this function only if the current invoice has not yet been issued or approved. Changes will apply to all open invoices and will not affect previously approved invoices."
        cancelButtonText="Cancel"
        ctaText="Continue"
        onSubmit={handleDialogSubmit}
      />
    </>
  );
};
